var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekAutocomplete, PeekInput } from "@piiqtechnologies/ui-components";
import { useUsers, useError, useLoader } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useMemo, useState } from "react";
export function UserSelectorAutocomplete(_a) {
    var { form, field } = _a, props = __rest(_a, ["form", "field"]);
    const [searchKey, setSearchKey] = useState();
    const [getUsers, users, usersLoading, usersError] = useUsers();
    const { setLoader } = useLoader();
    const { setError } = useError();
    useEffect(() => {
        if (form.values.organizationId) {
            getUsers({
                organizationId: form.values.organizationId,
                status: "active",
            });
        }
    }, [form.values.organizationId]);
    useEffect(() => {
        setLoader(usersLoading, "usersLoading");
        return () => setLoader(false, "usersLoading");
    }, [usersLoading]);
    useEffect(() => {
        if (usersError)
            setError(usersError === null || usersError === void 0 ? void 0 : usersError.message);
    }, [usersError]);
    const handleUserSelection = (_event, item) => {
        form.setFieldValue(field.name, item);
    };
    const options = useMemo(() => {
        var _a;
        if (!(users === null || users === void 0 ? void 0 : users.data))
            return [];
        return (_a = users.data) === null || _a === void 0 ? void 0 : _a.filter(({ name }) => !searchKey || name.match(new RegExp(searchKey, "i"))).map(({ _id, name }) => ({ id: _id, name }));
    }, [users === null || users === void 0 ? void 0 : users.data, searchKey]);
    if (!form.values.organizationId)
        return null;
    return (React.createElement(PeekAutocomplete, { freeSolo: false, clearIcon: null, popupIcon: null, onChange: handleUserSelection, options: (options === null || options === void 0 ? void 0 : options.length) ? options : [], getOptionLabel: ({ name }) => name, multiple: true, sx: { ".MuiAutocomplete-input": { pl: "4px !important" } }, value: options.find((option) => { var _a; return option.id === ((_a = field.value) === null || _a === void 0 ? void 0 : _a.id); }), isOptionEqualToValue: (option, value) => option.id === (value === null || value === void 0 ? void 0 : value.id), renderInput: (params) => (React.createElement(PeekInput, Object.assign({ field: Object.assign(Object.assign({}, field), { value: searchKey, onChange: (e) => setSearchKey(e.target.value) }), form: form }, params, props, { InputLabelProps: { required: true }, InputProps: Object.assign({}, params.InputProps) }))) }));
}
